/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {
  Modal,
  Button,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';

const propTypes = {
  intl: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  headerText: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
const defaultProps = {
  onConfirm: () => {},
  onCancel: () => {},
};

class DeleteModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  componentWillReceiveProps(nextProps) {
    const { showModal } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
  }

  render() {
    const { showModal } = this.state;
    const { headerText, text, onCancel, onConfirm } = this.props;
    return (
      <Modal
        bsClass="aisz-modal-danger"
        show={showModal}
        onHide={() => onCancel()}
      >
        <Modal.Header className="text-center" closeButton>
          {headerText}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>{text}</p>
          </div>
          <div className="text-center">
            <Button
              bsStyle="aisz-warning"
              onClick={() => onCancel()}
            >
              <i className="fa fa-exclamation-triangle" aria-hidden="true" />
              &nbsp;{this.intlMsg.msg('cancel')}
            </Button>&nbsp;
            <Button
              bsStyle="aisz-danger"
              onClick={() => onConfirm()}
            >
              <i className="fa fa-exclamation-triangle" aria-hidden="true" />
              &nbsp;{this.intlMsg.msg('confirm')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

DeleteModal.propTypes = propTypes;
DeleteModal.defaultProps = defaultProps;

export default injectIntl(DeleteModal);




// WEBPACK FOOTER //
// ./src/components/DeleteModal/index.jsx